import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-col-7" }
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Drive General", -1)
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Drive Docente", -1)
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Válido para", -1)
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "p-field p-col-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "hoursPerClass" }, "Horas por clase", -1)
const _hoisted_12 = { class: "p-col-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "Tipo*", -1)
const _hoisted_14 = { class: "p-grid" }
const _hoisted_15 = { class: "p-col-6" }
const _hoisted_16 = { class: "p-field-radiobutton" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "intensiveRadioButton" }, "Intensivo", -1)
const _hoisted_18 = { class: "p-col-6" }
const _hoisted_19 = { class: "p-field-radiobutton" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "regularRadioButton" }, "Regular", -1)
const _hoisted_21 = {
  key: 0,
  class: "p-error"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", null, "Público*", -1)
const _hoisted_23 = { class: "p-grid" }
const _hoisted_24 = { class: "p-col-6" }
const _hoisted_25 = { class: "p-field-radiobutton" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "b2cRadioButton" }, "B2C", -1)
const _hoisted_27 = { class: "p-col-6" }
const _hoisted_28 = { class: "p-field-radiobutton" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "b2bRadioButton" }, "B2B", -1)
const _hoisted_30 = {
  key: 0,
  class: "p-error"
}
const _hoisted_31 = { class: "p-field" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Comentario", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "scrollbar",
    onShow: _ctx.onShow,
    onHide: _ctx.onHide,
    modal: true,
    appendTo: "body",
    header: _ctx.modalTitle,
    style: { width: '50%' }
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        onClickOnce: _ctx.closeModal,
        label: "Cancelar",
        icon: "pi pi-times",
        class: "p-button-outlined"
      }, null, 8, ["onClickOnce"]),
      _createVNode(_component_Button, {
        form: "newSyllabusModalForm",
        type: "submit",
        label: "Guardar",
        icon: "pi pi-check"
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        id: "newSyllabusModalForm",
        class: "p-grid p-fluid",
        onSubmitOnce: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.onSubmit(!_ctx.v$.$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              modelValue: _ctx.formValues.links.folderLink,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formValues.links.folderLink = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              modelValue: _ctx.formValues.links.teacherFolderLink,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formValues.links.teacherFolderLink = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_CountrySelector, {
              optionValue: "id",
              modelValue: _ctx.formValues.language,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formValues.language = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", {
              for: "clientName",
              disabled: _ctx.formValues.target !== _ctx.SyllabusTarget.b2b
            }, "Ingresar el nombre del cliente*", 8, _hoisted_9),
            _createVNode(_component_InputText, {
              id: "clientName",
              modelValue: _ctx.formValues.clientName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formValues.clientName = $event)),
              disabled: _ctx.formValues.target !== _ctx.SyllabusTarget.b2b
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputNumber, {
              id: "hoursPerClass",
              modelValue: _ctx.formValues.modality.hoursPerClass,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formValues.modality.hoursPerClass = $event)),
              mode: "decimal",
              showButtons: "",
              min: 1,
              max: 8
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_RadioButton, {
                  id: "intensiveRadioButton",
                  value: _ctx.TypeModality.intensive,
                  modelValue: _ctx.formValues.modality.type,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formValues.modality.type = $event))
                }, null, 8, ["value", "modelValue"]),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_RadioButton, {
                  id: "regularRadioButton",
                  value: _ctx.TypeModality.regular,
                  modelValue: _ctx.formValues.modality.type,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formValues.modality.type = $event))
                }, null, 8, ["value", "modelValue"]),
                _hoisted_20
              ])
            ]),
            ((_ctx.v$.modality.type.$invalid && _ctx.submitted) || _ctx.v$.modality.type.$pending.$response)
              ? (_openBlock(), _createElementBlock("small", _hoisted_21, "El tipo de programa es requerido"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_RadioButton, {
                  id: "b2cRadioButton",
                  value: _ctx.SyllabusTarget.b2c,
                  modelValue: _ctx.formValues.target,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formValues.target = $event))
                }, null, 8, ["value", "modelValue"]),
                _hoisted_26
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_RadioButton, {
                  id: "b2bRadioButton",
                  value: _ctx.SyllabusTarget.b2b,
                  modelValue: _ctx.formValues.target,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formValues.target = $event))
                }, null, 8, ["value", "modelValue"]),
                _hoisted_29
              ])
            ]),
            ((_ctx.v$.target.$invalid && _ctx.submitted) || _ctx.v$.target.$pending.$response)
              ? (_openBlock(), _createElementBlock("small", _hoisted_30, "El público al que está dirigido el programa es un campo requerido"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createVNode(_component_Textarea, {
              rows: "4",
              placeholder: "Comentario extra",
              modelValue: _ctx.formValues.comment,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formValues.comment = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["onShow", "onHide", "header"]))
}